// extracted by mini-css-extract-plugin
export default {"main":"main_main__m4PoD","buttonWrap":"main_buttonWrap__gW0B3","noticeWrap":"main_noticeWrap__u194E"};